import { IconConfig, IconResourceType } from '@spartacus/storefront'

export const ebIconConfig: IconConfig = {
  icon: {
    symbols: {
      FLAG_GERMANY: 'flag-germany',
      FLAG_ITALY: 'flag-italy',
      FLAG_TURKEY: 'flag-turkey',
      FLAG_AUSTRIA: 'flag-austria'
    },
    resources: [
      {
        type: IconResourceType.SVG,
        url: '../../../public/icons/icon-sprite.svg',
        types: ['FLAG_GERMANY', 'FLAG_ITALY', 'FLAG_TURKEY', 'FLAG_AUSTRIA']
      }
    ]
  }
} as IconConfig
